package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_product_general.chat_model

import kotlinx.serialization.Serializable


@Serializable
data class ChatMessagesModel(
    var messages: MutableList<ChatSingleMessageModel>
)
